<template>
<!--  <div :id="element.uuid" :ref="element.uuid" :data-type="element.properties.element_type" :class="customClasses"  style="width: 400px;">-->
  <div :id="element.uuid" :ref="element.uuid" :data-type="element.properties.element_type" :class="customClasses" :style="setupFormInputVariables">
    <label :for="element.id">{{ element.properties.label | stripHtml }}<span v-if="!element.properties.required"> - Optional</span> </label>
    <input :id="element.id" v-model="textInput.value" :name="element.name" :placeholder="element.properties.placeholder | stripHtml" type="text" class="text-input form-element" @focus="setFocus"/>
    <p class="error-msg">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"><path fill="#d0021b" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 11c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1zm1 4h-2v-2h2v2z"/></svg>
      <span v-if="element.properties.required_message">{{ element.properties.required_message | stripHtml }}</span>
      <span v-else></span>
    </p>
  </div>
</template>

<script>
import { find } from 'lodash';
import HelperMethods from '../mixins/helper_methods';
import ElementEventHelper from '../mixins/element_event_helper';

export default {
  name: 'KioskTextInput',
  mixins: [HelperMethods, ElementEventHelper],
  props: {
    element: Object,
    kioskProperties: Object,
    sessionUuid: String,
    formData: Object,
    parentComponent: Object,
  },
  computed: {
    setupFormInputVariables() {
      const textInputHeight = parseInt(this.element.properties.text_input_height, 10);
      const textInputLineHeight = parseFloat(this.element.properties.text_input_line_height);
      const textInputFontSize = parseInt(this.element.properties.text_input_font_size, 10);
      const textInputLabelFontSize = parseInt(this.element.properties.text_input_label_font_size, 10);
      const textInputLabelHeight = parseInt(this.element.properties.text_input_label_height, 10);

      // Variables
      return {
        '--textInputHeight': `${textInputHeight}px`,
        '--textInputLineHeight': `${textInputLineHeight}`,
        '--textInputFontSize': `${textInputFontSize}px`,
        '--textInputLabelFontSize': `${textInputLabelFontSize}px`,
        '--textInputLabelHeight': `${textInputLabelHeight}px`,
      };
    },
  },
  watch: {
    textInput: {
      immediate: true,
      deep: true,
      handler(newVal) {
        // Compare and update form data if value has changed and doesn't currently exist
        if (!find(this.formData.inputs, newVal)) {
          // Check if the form field is required
          if (newVal.required) {
            // check for duplicates of the required field and add it to the array otherwise
            if (!find(this.formData.requiredFields, newVal)) {
              this.formData.requiredFields.push(newVal);
            }
          }
          this.formData.inputs.push(newVal);
        }
      },
    },
  },
  data() {
    return {
      properties: this.element.properties,
      textInput: {
        id: this.element.id,
        name: this.element.name,
        value: null,
        required: this.element.properties.required,
        validation: this.element.properties.input_validation,
      },
    };
  },
  methods: {
    resetCallback() {
      this.textInput = Object.assign({
        id: this.element.id,
        name: this.element.name,
        value: null,
        required: this.element.properties.required,
        validation: this.element.properties.input_validation,
      });
    },
    setFocus(e) {
      // Show keybord upon input focus
      const keyboard = {
        target: e.target.id,
        keyboard: this.parentComponent.properties.keyboard_select,
      };

      const newEvent = {};
      newEvent.type = 'open_keyboard';
      newEvent.target_uuid = keyboard.keyboard;
      newEvent.keyboard_target = keyboard.target;
      this.$eventHub.$emit(keyboard.keyboard, newEvent);
    },
    updateErrorMsg(validation) {
      // Check for validation and use the appropriate error message from the CMS (add new types via else-if and prop for CMS)
      if (validation) {
        if (validation === 'email') {
          this.element.properties.required_message = this.element.properties.email_required_message;
        }
      }
    },
    isEmailValid(email) {
      // Test the input value for a valid email address (element_event_helper)
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    },
  },
};
</script>

<style lang="scss" scoped>
  /*  Variables */
  $textInputHeight: var(--textInputHeight);
  $textInputLineHeight: var(--textInputLineHeight);
  $textInputFontSize: var(--textInputFontSize);
  $textInputLabelFontSize: var(--textInputLabelFontSize);
  $textInputLabelHeight: var(--textInputLabelHeight);

  label {
    display: block;
    text-align: left;
    color: rgb(51, 51, 51);
    font-size: $textInputLabelFontSize;
    font-weight: bold;
    height: $textInputLabelHeight;
    letter-spacing: 0px;
    font-family: 'Equip', sans-serif;
    span {
      color: #999999;
    }
  }
  .text-input {
    font-family: 'Equip', sans-serif;
    display: block;
    border: 1px solid rgb(153, 153, 153);
    border-radius: 0;
    height: $textInputHeight;
    font-size: $textInputFontSize;
    box-shadow: inset 0px 0px 10px 0px rgb(229, 229, 229);
    background: rgb(255, 255, 255);
    padding: 0 0 0 10px;
    line-height: $textInputLineHeight;
  }

  .error-msg {
    color: #b62626;
    font-size: $textInputLabelFontSize;
    text-align: left;
    display: none;
    font-family: 'Equip', sans-serif;
    span {
      padding: 0 0 0 5px;
    }
    &.active {
      display: block;
    }
  }
</style>
